import "./SunsetLandingPage.scss";
import { Box, Button, Card, CardActions, CardContent, Typography } from "@mui/material";
import React from "react";

export const SunsetLandingPage = () => {
    function handleClick() {
        window.location.href = "https://www.rpg.net";
    }

    return (
        <Box className="sunset-page-wrapper" style={{ backgroundImage: `url("/optimized_auth-bg.jpeg")` }}>
            <Card className="sunset-card">
                <CardContent className="sunset-card-content">
                    <Typography className="sunset-card-title" variant="h1">
                        🧙‍♂️ RPGmatch has entered a long rest...
                    </Typography>
                    <Typography className="sunset-card-text">
                        Like every great adventuring party, sometimes we need to pause, regroup, and prepare for the
                        next epic quest. RPGmatch is taking a Long Rest while we reforge the platform into something
                        even better for TTRPG players everywhere.
                        <br /> <br />
                        <span className="sunset-card-text-bold">
                            RPGmatch is not disappearing: we’re just between campaigns.
                        </span>
                        <br /> <br />
                        We appreciate your support, and we look forward to crossing paths with you on our next
                        adventures.
                    </Typography>
                </CardContent>
                <CardActions className="sunset-card-actions">
                    <Button className="sunset-card-button" variant="contained" onClick={handleClick}>
                        Go to RPGnet homepage
                    </Button>
                </CardActions>
            </Card>
        </Box>
    );
};
